import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'font-awesome/css/font-awesome.min.css';
import { ToastContainer } from 'react-toastify';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Spinner from './components/spinner/spinner';
import KeycloackContextProvider from './Context/KeycloakContext';

try {
  if (!sessionStorage.getItem("postLoginRedirect")) {
    const originalUrl = window.location.pathname + window.location.search;

    
    if (
      originalUrl !== "/" &&
      !originalUrl.includes("code=") &&
      !originalUrl.includes("session_state=")
    ) {
      sessionStorage.setItem("postLoginRedirect", originalUrl);
    }
  }
} catch (e) {
  console.error(e);
}



ReactDOM.render(
  <KeycloackContextProvider>
    <App />
    <ToastContainer />
    <Spinner />
  </KeycloackContextProvider>,
  document.getElementById('root')
);

reportWebVitals();
